import {ApiRes} from '../../types/api'
import {API_URL, apiGetV1} from '../api'

export interface IPointSummary {
    today_daily_check_count: {total: number; ko: number; en: number}
    total_amount: number
    yesterday_daily_check_count: {total: number; ko: number; en: number}
}

export const getPointSummary = async (): Promise<ApiRes<IPointSummary>> => {
    return await apiGetV1(API_URL, `admin/point/summary`)
}
